<template>
  <component :is="layoutComponent"
             :pageComponent="pageComponent"
             :leftSidebarComponent="leftSidebarComponent"
             :pageData="pageData" />
</template>

<script>
import BaseLayout from './BaseLayout'
import HeaderlessLayout from './HeaderlessLayout'

export default {
  components: {
    BaseLayout,
    HeaderlessLayout,
  },
  computed: {
    layoutComponent () {
      return window.layoutComponent || 'BaseLayout'
    },
    pageComponent () {
      return window.pageComponent || 'router-view'
    },
    leftSidebarComponent () {
      return window.leftSidebarComponent || ''
    },
    pageData () {
      return window.componentData || {}
    },
  },
  mounted(){
    if(window.statusMessage){
      this.$toast(window.statusMessage.type, window.statusMessage.content)
    }
  }
}
</script>
